import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { EIntegrationPlatform } from "../../models/integrations.model";
import { useIntegrations } from "../../providers/IntegrationsProvider";
import { useTheme } from "../../providers/ThemeProvider";
import { TConfig } from "../../services/apiWorker";
import { getAccessToken } from "../../services/integrations/spotify.service";
import { randomString } from "../../utils/randomString";

export const IntegrationSpotify = {
  type: EIntegrationPlatform.SPOTIFY,
  icon: "/assets/integrations/spotify.png",
  title: "Spotify",
  description: "Connect and manage Spotify features within your app.",

  openAuth: (config: TConfig) => {
    const str = randomString();

    const params: { [key: string]: string } = {
      client_id: config.auth.spotify.clientId,
      redirect_uri: config.auth.spotify.redirectUri,
      response_type: "code",
      scope: config.auth.spotify.scopes,
      state: str,
    };

    localStorage.setItem("spotifyState", str);

    setTimeout(() => {
      window.location.href = `https://accounts.spotify.com/authorize?${new URLSearchParams(
        params
      ).toString()}`;
    }, 100);
  },

  AuthRender: () => {
    const { addIntegration } = useIntegrations();
    const [searchParams, setSearchParams] = useSearchParams();
    const { message } = useTheme();

    useEffect(() => {
      const state = searchParams.get("state");

      if (state && state == localStorage.getItem("spotifyState")) {
        const code = searchParams.get("code");

        if (code) {
          searchParams.delete("code");
          searchParams.delete("state");

          localStorage.removeItem("spotifyState");

          setSearchParams(searchParams);

          getAccessToken({
            code,
            onSuccess: async (data) => {
              message.success("Spotify Integration done!");
              addIntegration(data);
            },
          });
        }
      }
    }, [searchParams]);

    return <></>;
  },
};
